import styled from '@emotion/styled';
import { COLORS } from '../../../../../constants/radar';

export const FormContainer = styled.div`
  flex: 1;
  background: white;
  overflow-y: auto;
  padding: 8px 24px 0 24px;
`;

export const AssignmentCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  min-height: 200px;
  height: 100%;
  overflow: hidden;
`;

export const AssignmentCardContent = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AssignmentTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 4px;
`;

export const AssignmentDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  > div {
    display: flex;
    gap: 8px;
    align-items: baseline;

    strong {
      min-width: 80px;
    }
  }
`;

export const ReviewersList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  max-width: 400px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const ItalicText = styled.div`
  color: ${COLORS.GRAY};
  font-size: 14px;
  font-style: italic;
`;

export const ActionButton = styled.button`
  background-color: ${COLORS.PRIMARY};
  color: white;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  height: 32px;
  line-height: 1.2;

  &:hover {
    background-color: ${COLORS.PRIMARY}ee;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${COLORS.PRIMARY}40;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`; 